//Get the list of objects for playerAmount dropDown.
export const playersInTotalDropDown = (start, amount, selectedItem) => {
  const result = [];
  for (let i = start; i < amount; i++) {
    const selected = i === selectedItem ? "selected" : "";
    result.push({ id: i, name: `${i} Players`, selected });
  }
  return result;
};
